(function() {
  'use strict';
  if (window.KinsoraSetPurchase) {
    window.KinsoraSetPurchase.init(document);
    return;
  }

  function failRoot(root) {
    if (root.ksPurchaseBoot) {
      root.ksPurchaseBoot.fail();
      return;
    }
    root.setAttribute('data-ks-purchase-state', 'error');
    var button = root.querySelector('[data-fb-atc]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'false');
      button.textContent = button.getAttribute('data-ks-initial-atc-label') || button.textContent;
    }
    var error = root.querySelector('[data-ks-purchase-load-error]');
    if (error) error.hidden = false;
    var refresh = root.querySelector('[data-ks-purchase-reload]');
    if (refresh) refresh.href = window.location.href;
  }

  // Liquid translations arrive HTML-escaped inside JSON. Undo that layer
  // once; escapeHtml still protects the final generated markup.
  function decodeTranslation(value) {
    var entities = {'&#39;': "'", '&#x27;': "'", '&apos;': "'", '&quot;': '"', '&amp;': '&', '&lt;': '<', '&gt;': '>'};
    return String(value == null ? '' : value).replace(/&(?:#39|#x27|apos|quot|amp|lt|gt);/gi, function(entity) {
      return entities[entity.toLowerCase()];
    });
  }

  function mount(root) {
      if (!root || root.getAttribute('data-ks-initialized') === 'true') return;

      var dataNode = root.querySelector('[data-fb-data]');
      var data;
      try {
        data = JSON.parse(dataNode.textContent);
        if (!data || !data.parent) throw new Error('Purchase data is unavailable.');
      } catch (error) {
        failRoot(root);
        return;
      }
      if (!window.KinsoraOffer) {
        failRoot(root);
        return;
      }
      root.setAttribute('data-ks-initialized', 'true');

      var singleMode = root.getAttribute('data-purchase-mode') === 'single';
      var singleAtcLabel = root.getAttribute('data-single-atc-label') || 'Add To Cart';
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      var listenerRemovers = [];
      var cleaned = false;
      var parentOptions = data.parentOptions || [];
      var parentVariants = data.parentVariants || [];
      var displayPricing = data.displayPricing || {};
      var fallbackLocked = Array.isArray(data.locked) ? data.locked.slice() : [];
      var locked = fallbackLocked.slice();
      var pools = {
        necklace: data.necklaces || [],
        pendant: data.pendants || [],
        bracelet: data.bracelets || []
      };
      var labels = data.labels || {};
      ['detailsFree', 'detailsSetTotal', 'detailsPayMore', 'detailsCartSavings', 'detailsCartCharge', 'detailsExtrasIncluded'].forEach(function(key) {
        if (typeof labels[key] === 'string') labels[key] = decodeTranslation(labels[key]);
      });
      var extras = [];
      var bogoState = root.querySelector('[data-ks-pdp-bogo]')
        ? {status: 'checking', selectedCount: 0, incrementalPayCents: null}
        : null;
      var lockedVariantIds = {};
      var pickerContext = null;
      var activeSheet = null;
      var activeTrigger = null;
      var busy = false;
      var addGeneration = 0;
      var unsafeCartState = false;
      var lastDisplayTotal = displayPricing.active
        ? Math.max(0, Number(displayPricing.price || 0))
        : Math.max(0, Number(data.parent.price || 0));
      var lastDisplayFullTotal = lastDisplayTotal;
      var bodyState = null;
      var removalObserver = null;

      var pieceCountNode = root.querySelector('[data-fb-piece-count]');
      var previewNode = root.querySelector('[data-fb-preview]');
      var detailsOpenButton = root.querySelector('[data-fb-details-open]');
      var detailsSheet = root.querySelector('[data-fb-details]');
      var detailsSummaryNode = root.querySelector('[data-fb-details-summary]');
      var detailsListNode = root.querySelector('[data-fb-details-list]');
      var variantOptionsNode = root.querySelector('[data-fb-variant-options]');
      var setLookNode = root.querySelector('[data-ks-set-look]');
      var setLookPiecesNode = root.querySelector('[data-ks-look-pieces]');
      var saveNode = root.querySelector('[data-fb-save]');
      var nowNode = root.querySelector('[data-fb-now]');
      var wasNode = root.querySelector('[data-fb-was]');
      var priceA11yNode = root.querySelector('[data-fb-price-a11y]');
      var addButton = root.querySelector('[data-fb-atc]');
      var detailsAddButton = root.querySelector('[data-fb-details-add]');
      var errorNode = root.querySelector('[data-fb-error]');
      var paymentNode = root.querySelector('[data-fb-payment]');
      var paymentVariantInput = root.querySelector('[data-payment-terms-variant-id]');
      var parentOptionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-fb-parent-option]'));
      var pickerSheet = root.querySelector('[data-fb-picker]');
      var pickerList = root.querySelector('[data-fb-picker-list]');
      var pickerTitle = root.querySelector('[data-fb-picker-title]');
      var deliveryNode = root.querySelector('.ks-set-purchase__delivery [data-min-days]');
      var money = window.Kinsora && window.Kinsora.formatMoney
        ? window.Kinsora.formatMoney
        : function(cents) { return '$' + (Math.max(0, Number(cents || 0)) / 100).toFixed(2); };

      function displayParentPrice() {
        return displayPricing.active
          ? Math.max(0, Number(displayPricing.price || 0))
          : Math.max(0, Number(data.parent.price || 0));
      }

      function displayParentFullPrice() {
        if (displayPricing.active) return Math.max(0, Number(displayPricing.fullPrice || 0));
        return Math.max(0, Number(data.parent.compareAtPrice || 0));
      }

      function listen(target, type, handler, options) {
        if (!target) return;
        var settings = options || {};
        if (signal) settings.signal = signal;
        target.addEventListener(type, handler, settings);
        listenerRemovers.push(function() { target.removeEventListener(type, handler, settings); });
      }

      function escapeHtml(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
          return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character];
        });
      }

      function rebuildLockedVariantIds() {
        lockedVariantIds = {};
        locked.forEach(function(item) {
          lockedVariantIds[String(item.variantId)] = true;
        });
      }

      function cleanSpecs(item) {
        var values = [];
        var source = Array.isArray(item.options) && item.options.length
          ? item.options
          : String(item.label || '').split(' / ');
        source.forEach(function(value) {
          var cleanedValue = String(value || '').trim();
          var normalized = cleanedValue.toLowerCase();
          if (!cleanedValue || normalized === 'default title') return;
          if (values.some(function(existing) { return existing.toLowerCase() === normalized; })) return;
          values.push(cleanedValue);
        });
        return values.join(' · ');
      }

      function imageHtml(item, className, size, alt) {
        if (!item || !item.img) {
          return '<span class="' + className + ' ' + className + '--placeholder" aria-hidden="true"></span>';
        }
        var sources = [escapeHtml(item.img) + ' 76w'];
        if (item.img2x && item.img2x !== item.img) sources.push(escapeHtml(item.img2x) + ' 152w');
        if (item.img3x && item.img3x !== item.img) sources.push(escapeHtml(item.img3x) + ' 228w');
        var sizes = size + 'px';
        if (className === 'ks-look__image') sizes = '(max-width: 359px) 30px, 36px';
        if (className === 'ks-set-detail-row__image') sizes = '(max-width: 359px) 56px, 64px';
        if (className === 'ks-set-picker__image') sizes = '(max-width: 359px) 52px, 60px';
        return '<img class="' + className + '" src="' + escapeHtml(item.img2x || item.img) + '"'
          + ' srcset="' + sources.join(', ') + '" sizes="' + sizes + '"'
          + ' alt="' + escapeHtml(alt || '') + '" loading="lazy" width="' + size + '" height="' + size + '">';
      }

      function selectedParentOptions() {
        var values = [];
        parentOptionInputs.forEach(function(input) {
          if (input.type !== 'hidden' && !input.checked) return;
          values[Number(input.getAttribute('data-fb-option-position')) - 1] = input.value;
        });
        return values;
      }

      function findParentVariant(options) {
        for (var index = 0; index < parentVariants.length; index += 1) {
          var candidate = parentVariants[index];
          if (!Array.isArray(candidate.options) || candidate.options.length !== options.length) continue;
          if (candidate.options.every(function(value, optionIndex) {
            return String(value) === String(options[optionIndex]);
          })) return candidate;
        }
        return null;
      }

      function selectedOptionValue(option) {
        var selected = '';
        parentOptionInputs.forEach(function(input) {
          if (Number(input.getAttribute('data-fb-option-position')) !== Number(option.position)) return;
          if (input.type === 'hidden' || input.checked) selected = input.value;
        });
        return selected;
      }

      function optionValueAvailable(option, value) {
        var options = selectedParentOptions();
        options[Number(option.position) - 1] = value;
        var variant = findParentVariant(options);
        return !!variant && variant.available !== false;
      }

      function renderParentOptions() {
        if (!variantOptionsNode) return;
        variantOptionsNode.innerHTML = parentOptions.filter(function(option) {
          if (!Array.isArray(option.values) || !option.values.length) return false;
          // A fixed chain length is useful sizing information, even without a choice.
          var isLength = /length/i.test(String(option.name || ''));
          var hasLengthValue = option.values.some(function(value) {
            return /\d(?:[.,]\d+)?\s*(?:inches?|in\b|cm\b|mm\b|["\u2033])/i.test(String(value.name || ''));
          });
          return option.values.length > 1 || isLength || hasLengthValue;
        }).map(function(option) {
          var selected = selectedOptionValue(option);
          var choices = option.values.map(function(valueData) {
            var value = valueData.name || '';
            var isSelected = String(value) === String(selected);
            var available = valueData.available !== false && optionValueAvailable(option, value);
            return '<button type="button" class="ks-set-option' + (isSelected ? ' is-selected' : '') + '"'
              + ' data-ks-parent-value="' + escapeHtml(value) + '" data-ks-option-position="' + option.position + '"'
              + ' aria-pressed="' + (isSelected ? 'true' : 'false') + '"' + (available ? '' : ' disabled') + '>'
              + escapeHtml(value) + '</button>';
          }).join('');
          return '<fieldset class="ks-set-options"><legend>' + escapeHtml(option.name) + '</legend><div>' + choices + '</div></fieldset>';
        }).join('');
        variantOptionsNode.hidden = !variantOptionsNode.innerHTML;
      }

      function renderIncluded() {
        var count = locked.length;
        if (setLookNode && setLookPiecesNode) {
          setLookPiecesNode.innerHTML = locked.map(function(item) {
            return imageHtml(item, 'ks-look__image', 36, '');
          }).join('');
          setLookNode.hidden = !count;
        }
        pieceCountNode.textContent = count + (count === 1 ? ' PIECE INCLUDED' : ' PIECES INCLUDED');
        previewNode.setAttribute('aria-label', count + (count === 1 ? ' piece included' : ' pieces included'));
        var visible = locked.slice(0, 4);
        previewNode.innerHTML = visible.map(function(item) {
          return '<span class="ks-set-purchase__preview-item">' + imageHtml(item, 'ks-set-purchase__preview-image', 76, '') + '</span>';
        }).join('') + (count > 4 ? '<span class="ks-set-purchase__preview-more" aria-label="' + (count - 4) + ' more included pieces">+' + (count - 4) + '</span>' : '');

        detailsSummaryNode.textContent = count + (count === 1 ? ' piece' : ' pieces');
        var detailItems = window.KinsoraOffer.purchaseItems(data.parent.offerItems, []);
        var detailProjection = window.KinsoraOffer.project(detailItems);
        detailsListNode.innerHTML = locked.map(function(item) {
          var itemIndex = detailItems.findIndex(function(piece) { return String(piece.id) === String(item.variantId); });
          var allocation = detailProjection.allocations[itemIndex];
          var piece = detailItems[itemIndex];
          var current = allocation ? allocation.payCents : Number(item.price || 0);
          var regular = Math.max(Number(item.price || 0), piece ? Number(piece.compareAtPrice || 0) : 0);
          var priceHtml = (regular > current ? '<s class="ks-detail-price-was">' + escapeHtml(money(regular)) + '</s>' : '')
            + '<span class="ks-detail-price-now">' + escapeHtml(money(current)) + '</span>';
          var specs = cleanSpecs(item);
          return '<div class="ks-set-detail-row">'
            + imageHtml(item, 'ks-set-detail-row__image', 64, '')
            + '<span class="ks-set-detail-row__copy"><strong>' + escapeHtml(item.title) + '</strong>'
            + (specs ? '<span>' + escapeHtml(specs) + '</span>' : '') + '</span>'
            + '<span class="ks-set-detail-row__status">' + priceHtml + '</span></div>';
        }).join('');
      }

      function findVariant(type, variantId) {
        var pool = pools[type] || [];
        for (var productIndex = 0; productIndex < pool.length; productIndex += 1) {
          var variants = pool[productIndex].variants || [];
          for (var variantIndex = 0; variantIndex < variants.length; variantIndex += 1) {
            if (String(variants[variantIndex].id) === String(variantId)) {
              return {product: pool[productIndex], variant: variants[variantIndex]};
            }
          }
        }
        return null;
      }

      function makeExtra(type, productData, variantData) {
        return {
          type: type,
          title: productData.title,
          img: productData.img,
          img2x: productData.img2x || '',
          img3x: productData.img3x || '',
          variantId: variantData.id,
          label: variantData.label || '',
          options: variantData.options || [],
          price: variantData.price,
          offerItems: variantData.offerItems || [],
          locked: false
        };
      }

      function extraDisplayPrice(item) {
        return Math.max(0, Number(item.displayPrice != null ? item.displayPrice : item.price || 0));
      }

      function extraFullPrice(item) {
        var fullPrice = Math.max(0, Number(item.displayFullPrice || 0));
        return fullPrice > extraDisplayPrice(item) ? fullPrice : extraDisplayPrice(item);
      }

      function basePurchaseItems() {
        return window.KinsoraOffer
          ? window.KinsoraOffer.purchaseItems(data.parent.offerItems, extras)
          : [];
      }

      root.ksPdpSelection = function() {
        return {
          variantId: Number(data.parent.variantId),
          title: String(data.parent.title || ''),
          handle: String(data.parent.handle || ''),
          available: data.parent.available !== false,
          price: Math.max(0, Number(data.parent.price || 0)),
          displayPrice: displayParentPrice(),
          displayFullPrice: Math.max(displayParentFullPrice(), displayParentPrice()),
          items: basePurchaseItems()
        };
      };

      function renderExtras() {
        root.dispatchEvent(new CustomEvent('kinsora:pdp-selection-changed', {
          bubbles: true,
          detail: root.ksPdpSelection()
        }));
      }

      function syncPaymentTerms(total) {
        if (!paymentNode) return;
        if (paymentVariantInput) paymentVariantInput.value = String(data.parent.variantId);
        if (window.Kinsora && typeof window.Kinsora.updatePaymentTerms === 'function') {
          window.Kinsora.updatePaymentTerms(data.parent.variantId, total);
        } else {
          paymentNode.querySelectorAll('shopify-payment-terms').forEach(function(widget) {
            widget.setAttribute('variant-id', String(data.parent.variantId));
          });
        }
        if (total >= 5000 && total < 100000) {
          paymentNode.hidden = false;
          paymentNode.classList.add('kinsora-pt-ready');
          paymentNode.querySelectorAll('[data-combined-installment-amount]').forEach(function(amountNode) {
            amountNode.textContent = money(Math.round(total / 4));
          });
          paymentNode.setAttribute('data-kinsora-base-cents', String(total));
          paymentNode.setAttribute('data-kinsora-discount-pct', '0');
          if (window.Kinsora && window.Kinsora.shopPayOverride) {
            paymentNode.querySelectorAll('shopify-payment-terms').forEach(function(widget) {
              window.Kinsora.shopPayOverride.applyOverride(widget);
            });
          }
        } else {
          paymentNode.hidden = true;
        }
      }

      function syncOriginalSticky() {
        var bar = document.getElementById(singleMode ? 'stickyATC' : 'stickyATCStack');
        if (!bar) return;
        var price = bar.querySelector('[data-sticky-atc-price]');
        var button = bar.querySelector('.sticky-atc__btn');
        if (price) {
          var priceHtml = '';
          if (lastDisplayFullTotal > lastDisplayTotal) priceHtml += '<s class="sticky-atc__price-compare">' + money(lastDisplayFullTotal) + '</s>';
          priceHtml += '<span class="price-current">' + money(lastDisplayTotal) + '</span>';
          price.innerHTML = priceHtml;
        }
        if (!button) return;
        button.disabled = addButton.disabled;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
        var label = addButton.textContent.trim();
        if (button.textContent !== label) button.textContent = label;
      }

      function onDetailsAddToCart(event) {
        event.preventDefault();
        if (busy || addButton.disabled) return;
        closeSheet(detailsSheet, true);
        addButton.focus({preventScroll: true});
        addButton.click();
      }

      function onOriginalStickyClick(event) {
        var stickySelector = singleMode ? '#stickyATC .sticky-atc__btn' : '#stickyATCStack .sticky-atc__btn';
        var button = event.target && event.target.closest ? event.target.closest(stickySelector) : null;
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        if (!addButton.disabled) addButton.click();
      }

      function renderPrice() {
        var purchaseItems = basePurchaseItems();
        var offer = window.KinsoraOffer;
        var projection = offer ? offer.project(purchaseItems) : null;
        var bogoReady = bogoState && bogoState.status === 'ready' && Number(bogoState.incrementalPayCents) >= 0;
        lastDisplayFullTotal = purchaseItems.reduce(function(total, item) { return total + item.price * item.quantity; }, 0);
        lastDisplayTotal = projection ? projection.incrementalPayCents : lastDisplayFullTotal;
        var selectionUnavailable = !purchaseItems.length || purchaseItems.some(function(item) { return !item.id || item.available === false; });
        lastDisplayFullTotal = purchaseItems.reduce(function(total, item) { return total + Math.max(Number(item.price), Number(item.compareAtPrice || 0)) * item.quantity; }, 0);
        var hasSavings = lastDisplayFullTotal > lastDisplayTotal;
        var savings = hasSavings ? lastDisplayFullTotal - lastDisplayTotal : 0;

        nowNode.textContent = money(lastDisplayTotal);
        wasNode.textContent = hasSavings ? money(lastDisplayFullTotal) : '';
        wasNode.hidden = !hasSavings;
        saveNode.textContent = '';
        saveNode.hidden = true;
        var detailsTotal = root.querySelector('[data-fb-details-total]');
        if (detailsTotal) {
          var setItems = window.KinsoraOffer.purchaseItems(data.parent.offerItems, []);
          var setProjection = window.KinsoraOffer.project(setItems);
          var setRegular = setItems.reduce(function(total, item) { return total + Math.max(Number(item.price), Number(item.compareAtPrice || 0)) * item.quantity; }, 0);
          detailsTotal.innerHTML = (setRegular > setProjection.incrementalPayCents ? '<s data-ks-offer-regular>' + escapeHtml(money(setRegular)) + '</s>' : '')
            + '<span data-ks-offer-current>' + escapeHtml(money(setProjection.incrementalPayCents)) + '</span>';
        }
        priceA11yNode.textContent = hasSavings
          ? 'Regular total ' + money(lastDisplayFullTotal) + '. Current Add to Cart total ' + money(lastDisplayTotal) + '.'
          : 'Current Add to Cart total ' + money(lastDisplayTotal) + '.';

        var baseLabel = root.getAttribute('data-single-atc-label') || 'Add To Cart';
        if (busy) addButton.textContent = labels.adding || 'ADDING';
        else if (selectionUnavailable) addButton.textContent = 'SOLD OUT';
        else addButton.textContent = baseLabel;
        var bogoPending = bogoState && (bogoState.status === 'checking' || bogoState.status === 'invalid');
        addButton.disabled = busy || unsafeCartState || bogoPending || selectionUnavailable || !offer;
        addButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (detailsAddButton) {
          detailsAddButton.disabled = addButton.disabled;
          detailsAddButton.setAttribute('aria-busy', busy ? 'true' : 'false');
          detailsAddButton.textContent = addButton.textContent;
        }
        syncPaymentTerms(lastDisplayTotal);
        syncOriginalSticky();
      }

      function render() {
        renderIncluded();
        renderParentOptions();
        renderExtras();
        renderPrice();
      }

      function onBogoState(event) {
        bogoState = event && event.detail ? event.detail : null;
        renderPrice();
      }

      function applyParentVariant(parentVariant, updateUrl) {
        if (!parentVariant) return;
        data.parent.offerItems = parentVariant.offerItems || [];
        data.parent.variantId = parentVariant.variantId;
        data.parent.price = parentVariant.price;
        data.parent.compareAtPrice = parentVariant.compareAtPrice;
        data.parent.available = parentVariant.available !== false;
        locked = Array.isArray(parentVariant.locked) && parentVariant.locked.length
          ? parentVariant.locked.slice()
          : fallbackLocked.slice();
        data.parent.pieceCount = locked.length;
        rebuildLockedVariantIds();
        extras = extras.filter(function(item) { return !lockedVariantIds[String(item.variantId)]; });
        if (paymentVariantInput) paymentVariantInput.value = String(parentVariant.variantId);
        if (singleMode && parentVariant.featuredImage) {
          var featuredIndex = Number(parentVariant.featuredImageIndex);
          if (featuredIndex >= 0 && window.Kinsora && typeof window.Kinsora.galleryGoTo === 'function') {
            // Variant choices are authoritative. Bypass the gallery's short
            // swipe/click lock so two quick option changes cannot leave the
            // previous variant image visible while the selected ID advances.
            window.Kinsora.galleryGoTo(featuredIndex, true);
          } else if (window.Kinsora && typeof window.Kinsora.galleryShowImage === 'function') {
            window.Kinsora.galleryShowImage(parentVariant.featuredImage);
          } else {
            var mainImage = document.getElementById('mainImage');
            if (mainImage) {
              var source = window.Kinsora && typeof window.Kinsora.galleryImageSource === 'function'
                ? window.Kinsora.galleryImageSource(parentVariant.featuredImage)
                : {src: parentVariant.featuredImage};
              if (source.sizes) mainImage.setAttribute('sizes', source.sizes);
              if (source.srcset) mainImage.setAttribute('srcset', source.srcset);
              else mainImage.removeAttribute('srcset');
              mainImage.src = source.src;
            }
          }
        }
        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(parentVariant.variantId));
          window.history.replaceState({}, '', url.toString());
        }
        render();
      }

      root.ksSelectVariant = function(variantId) {
        if (busy || unsafeCartState) return false;
        var variant = parentVariants.find(function(item) { return String(item.variantId) === String(variantId); });
        if (!variant || variant.available === false) return false;
        applyParentVariant(variant, true);
        return true;
      };

      function lockBody() {
        if (bodyState) return;
        bodyState = {
          scrollY: window.scrollY,
          overflow: document.body.style.overflow,
          position: document.body.style.position,
          top: document.body.style.top,
          width: document.body.style.width,
          paddingRight: document.body.style.paddingRight
        };
        var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        if (scrollbarWidth) {
          document.body.style.paddingRight = (parseFloat(window.getComputedStyle(document.body).paddingRight) + scrollbarWidth) + 'px';
        }
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + bodyState.scrollY + 'px';
        document.body.style.width = '100%';
      }

      function unlockBody() {
        if (!bodyState) return;
        var state = bodyState;
        bodyState = null;
        document.body.style.overflow = state.overflow;
        document.body.style.position = state.position;
        document.body.style.top = state.top;
        document.body.style.width = state.width;
        document.body.style.paddingRight = state.paddingRight;
        window.scrollTo(0, state.scrollY);
      }

      function focusableElements(sheet) {
        return Array.prototype.slice.call(sheet.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function(element) {
          return element.tabIndex >= 0 && !element.hidden && element.getAttribute('aria-hidden') !== 'true';
        });
      }

      function openSheet(sheet, trigger) {
        if (!sheet || activeSheet === sheet) return;
        if (activeSheet) closeSheet(activeSheet, false);
        activeSheet = sheet;
        activeTrigger = trigger || document.activeElement;
        if (activeTrigger && activeTrigger.setAttribute) activeTrigger.setAttribute('aria-expanded', 'true');
        sheet.hidden = false;
        sheet.setAttribute('aria-hidden', 'false');
        lockBody();
        if (typeof sheet.showModal === 'function') sheet.showModal();
        else sheet.setAttribute('open', '');
        var closeButton = sheet.querySelector('.wp-pick__x');
        window.requestAnimationFrame(function() { if (closeButton) closeButton.focus(); });
      }

      function closeSheet(sheet, restoreFocus) {
        if (!sheet) return;
        if (sheet.open && typeof sheet.close === 'function') sheet.close();
        else sheet.removeAttribute('open');
        sheet.hidden = true;
        sheet.setAttribute('aria-hidden', 'true');
        var trigger = activeTrigger;
        if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'false');
        if (activeSheet === sheet) {
          if (sheet === pickerSheet) pickerContext = null;
          activeSheet = null;
          activeTrigger = null;
          unlockBody();
          if (restoreFocus !== false && trigger && trigger.isConnected) trigger.focus();
        }
      }

      function closeActiveSheet(restoreFocus) {
        if (activeSheet) closeSheet(activeSheet, restoreFocus);
      }

      function pickerHeading(type) {
        if (type === 'pendant') return 'ADD A PENDANT';
        if (type === 'bracelet') return 'ADD A BRACELET';
        return 'ADD A CHAIN';
      }

      function renderPicker() {
        if (!pickerContext) return;
        var type = pickerContext.type;
        var selectedId = pickerContext.mode === 'change' && extras[pickerContext.index]
          ? String(extras[pickerContext.index].variantId)
          : '';
        var usedIds = Object.assign({}, lockedVariantIds);
        extras.forEach(function(item, index) {
          if (!(pickerContext.mode === 'change' && index === pickerContext.index)) usedIds[String(item.variantId)] = true;
        });
        pickerTitle.textContent = pickerHeading(type);

        pickerList.innerHTML = (pools[type] || []).map(function(productData, productIndex) {
          var variants = productData.variants || [];
          var header = imageHtml(productData, 'ks-set-picker__image', 68, '')
            + '<span class="ks-set-picker__copy"><strong>' + escapeHtml(productData.title) + '</strong></span>';
          if (variants.length <= 1) {
            var variant = variants[0] || {};
            var used = !!usedIds[String(variant.id)];
            var selected = selectedId && String(variant.id) === selectedId;
            var unavailable = variant.available === false;
            var action = used ? (lockedVariantIds[String(variant.id)] ? 'INCLUDED' : 'ADDED') : '+ ADD';
            return '<button type="button" class="ks-set-picker-product' + (selected ? ' is-selected' : '') + '"'
              + ' data-fb-product="' + productIndex + '" data-fb-variant="0"'
              + ((used || unavailable) ? ' disabled' : '') + (used ? ' data-added="1"' : '') + '>'
              + header + '<span class="ks-set-picker-product__meta">'
              + (cleanSpecs({label: variant.label}) ? '<span>' + escapeHtml(cleanSpecs({label: variant.label})) + '</span>' : '')
              + '<strong>' + money(variant.price || 0) + '</strong></span><span class="ks-set-picker-product__action">' + action + '</span></button>';
          }

          var variantButtons = variants.map(function(variant, variantIndex) {
            var used = !!usedIds[String(variant.id)];
            var selected = selectedId && String(variant.id) === selectedId;
            var unavailable = variant.available === false;
            var action = used ? (lockedVariantIds[String(variant.id)] ? 'INCLUDED' : 'ADDED') : '+ ADD';
            return '<button type="button" class="ks-set-picker-variant' + (selected ? ' is-selected' : '') + '"'
              + ' data-fb-product="' + productIndex + '" data-fb-variant="' + variantIndex + '"'
              + ((used || unavailable) ? ' disabled' : '') + (used ? ' data-added="1"' : '') + '>'
              + '<span>' + escapeHtml(variant.label || ('Option ' + (variantIndex + 1))) + '</span>'
              + '<strong>' + money(variant.price || 0) + '</strong><span>' + action + '</span></button>';
          }).join('');
          return '<div class="ks-set-picker-group"><div class="ks-set-picker-group__head">' + header + '</div><div class="ks-set-picker-group__options">' + variantButtons + '</div></div>';
        }).join('');
        pickerList.scrollTop = 0;
      }

      function openPicker(type, mode, index, trigger) {
        pickerContext = {type: type, mode: mode, index: index};
        renderPicker();
        openSheet(pickerSheet, trigger);
      }

      function setDeliveryEstimate() {
        if (!deliveryNode) return;
        var minDays = parseInt(deliveryNode.getAttribute('data-min-days'), 10) || 5;
        var maxDays = parseInt(deliveryNode.getAttribute('data-max-days'), 10) || 10;
        var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        function addBusinessDays(start, days) {
          var date = new Date(start.getTime());
          var added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
          }
          return date;
        }
        var shipStart = addBusinessDays(new Date(), 2);
        var minimum = addBusinessDays(shipStart, minDays);
        var maximum = addBusinessDays(shipStart, maxDays);
        var minText = months[minimum.getMonth()] + ' ' + minimum.getDate();
        var maxText = minimum.getMonth() === maximum.getMonth()
          ? maximum.getDate()
          : months[maximum.getMonth()] + ' ' + maximum.getDate();
        deliveryNode.textContent = 'Arrives between ' + minText + '–' + maxText;
      }

      function onRootClick(event) {
        var closeControl = event.target.closest('[data-fb-details-close], [data-fb-picker-close]');
        if (closeControl) {
          closeActiveSheet(true);
          return;
        }

        var detailsOpen = event.target.closest('[data-fb-details-open]');
        if (detailsOpen) {
          openSheet(detailsSheet, detailsOpen);
          return;
        }

        if (busy) return;

        var addControl = event.target.closest('[data-fb-add]');
        if (addControl) {
          var type = addControl.getAttribute('data-fb-add');
          if ((pools[type] || []).length) openPicker(type, 'add', -1, addControl);
          return;
        }

        var parentValue = event.target.closest('[data-ks-parent-value]');
        if (parentValue && !parentValue.disabled) {
          var position = Number(parentValue.getAttribute('data-ks-option-position'));
          var value = parentValue.getAttribute('data-ks-parent-value');
          parentOptionInputs.forEach(function(input) {
            if (Number(input.getAttribute('data-fb-option-position')) !== position) return;
            if (String(input.value) === String(value)) input.checked = true;
          });
          applyParentVariant(findParentVariant(selectedParentOptions()), true);
          return;
        }

        var removeControl = event.target.closest('[data-fb-remove]');
        if (removeControl) {
          extras.splice(Number(removeControl.getAttribute('data-fb-remove')), 1);
          render();
          return;
        }

        var changeControl = event.target.closest('[data-fb-change]');
        if (changeControl) {
          var changeIndex = Number(changeControl.getAttribute('data-fb-change'));
          if (extras[changeIndex]) openPicker(extras[changeIndex].type, 'change', changeIndex, changeControl);
          return;
        }

        var pickerChoice = event.target.closest('[data-fb-variant]');
        if (pickerChoice && pickerContext && !pickerChoice.disabled && !pickerChoice.getAttribute('data-added')) {
          var productData = (pools[pickerContext.type] || [])[Number(pickerChoice.getAttribute('data-fb-product'))];
          var variantData = productData && (productData.variants || [])[Number(pickerChoice.getAttribute('data-fb-variant'))];
          if (!productData || !variantData) return;
          var selectedType = pickerContext.type;
          var selectedMode = pickerContext.mode;
          var selectedIndex = pickerContext.index;
          var extra = makeExtra(selectedType, productData, variantData);
          if (selectedMode === 'change' && extras[selectedIndex]) {
            extras[selectedIndex] = extra;
            activeTrigger = root.querySelector('[data-fb-add="' + selectedType + '"]') || activeTrigger;
          }
          else extras.push(extra);
          pickerContext = null;
          closeSheet(pickerSheet, true);
          render();
        }
      }

      function onDocumentKeydown(event) {
        if (!activeSheet) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeActiveSheet(true);
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = focusableElements(activeSheet);
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function onAddToCart() {
        if (busy || !window.KinsoraOffer || !basePurchaseItems().length || basePurchaseItems().some(function(item) { return !item.id || item.available === false; })) return;
        busy = true;
        errorNode.hidden = true;
        renderPrice();

        var items = basePurchaseItems().map(function(item) {
          return {id: Number(item.id), quantity: item.quantity, properties: item.properties || {}};
        });
        var bogoController = root.ksPdpBogo;
        var requireBogoPrepare = !!(bogoController && bogoState && bogoState.status === 'ready');
        var bogoClickSignature = requireBogoPrepare ? bogoState.purchaseSignature : null;
        var prepared = null;
        var committed = false;
        var expressVerificationResolve = null;
        var expressVerificationSettled = false;

        function settleExpressVerification(verified) {
          if (expressVerificationSettled || typeof expressVerificationResolve !== 'function') return;
          expressVerificationSettled = true;
          expressVerificationResolve(verified === true);
        }

        if (!items[0].id || isNaN(items[0].id)) {
          busy = false;
          errorNode.hidden = false;
          renderExtras();
          renderPrice();
          return;
        }

        var expressAttempt = document.body.classList.contains('kinsora-expressing')
          && window.Kinsora ? window.Kinsora._expressAttempt : null;
        if (requireBogoPrepare && expressAttempt) {
          expressAttempt.kinsoraPdpVerificationPromise = new Promise(function(resolve) {
            expressVerificationResolve = resolve;
          });
        }

        if (requireBogoPrepare && (typeof bogoController.lock !== 'function'
          || !bogoController.lock(bogoClickSignature))) {
          settleExpressVerification(false);
          busy = false;
          errorNode.textContent = 'Your BOGO price is updating. Review the total and try again.';
          errorNode.hidden = false;
          renderPrice();
          return;
        }

        var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        // Bound the response and its body. A timed-out write may still have committed.
        function withCartRequestDeadline(options, request) {
          var controller = new AbortController();
          var timer;
          var deadline = new Promise(function(resolve, reject) {
            timer = window.setTimeout(function() {
              var error = new Error('The cart request timed out. Please refresh and review your cart before trying again.');
              error.kinsoraCartRequestTimeout = true;
              var method = String(options && options.method || 'GET').toUpperCase();
              if (method !== 'GET' && method !== 'HEAD') error.kinsoraUnsafeCartState = true;
              reject(error);
              controller.abort();
            }, 15000);
          });
          return Promise.race([Promise.resolve().then(function() {
            return request(controller.signal);
          }), deadline]).finally(function() { window.clearTimeout(timer); });
        }
        function fetchCartJson(path, options) {
          return withCartRequestDeadline(options, function(signal) {
            return fetch(rootPath + path, Object.assign({credentials: 'same-origin'}, options || {}, {signal: signal})).then(function(response) {
              return response.json().catch(function() { return {}; }).then(function(payload) {
                if (!response.ok) {
                  var requestError = new Error(payload.description || payload.message || 'The cart request could not be completed.');
                  requestError.status = response.status;
                  throw requestError;
                }
                return payload;
              });
            });
          });
        }
        var cartRevealed = false;
        function revealCartAfterAdd() {
          if (cartRevealed || document.body.classList.contains('kinsora-expressing')) return;
          cartRevealed = true;
          busy = false;
          errorNode.hidden = true;
          renderPrice();
          if (window.Kinsora && typeof window.Kinsora.openCart === 'function') {
            window.Kinsora.openCart({skipVerification: true});
          } else {
            window.location.href = rootPath + 'cart';
          }
        }
        var operation = async function() {
          if (requireBogoPrepare && typeof bogoController.prepare === 'function') {
            var before = await fetchCartJson('cart.js', {cache: 'no-store'});
            prepared = await bogoController.prepare(before, bogoClickSignature);
            items = prepared.items;
            if (expressAttempt) {
              expressAttempt.kinsoraPdpVerificationCheck = function(cart) {
                return bogoController.verify(prepared, cart);
              };
            }
          }

          var addError = null;
          try {
            await fetchCartJson('cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items: items})
            });
            // A plain add has no quote to roll back. Release the button before
            // the follow-up cart read and gift proof. A priced BOGO quote still
            // waits until that quote verifies, so a failed proof can roll back.
            if (!prepared) {
              committed = true;
              revealCartAfterAdd();
            }
          } catch (error) {
            addError = error;
          }

          var actual;
          try {
            actual = await fetchCartJson('cart.js', {cache: 'no-store'});
          } catch (readError) {
            readError.kinsoraUnsafeCartState = true;
            throw readError;
          }

          if (prepared) {
            if (bogoController.verify(prepared, actual)) {
              committed = true;
              settleExpressVerification(true);
              return actual;
            }
            try {
              await bogoController.rollback(prepared);
            } catch (rollbackError) {
              rollbackError.kinsoraUnsafeCartState = true;
              throw rollbackError;
            }
            throw addError || new Error('Shopify could not add this selection at the quoted price. Please try again.');
          }
          if (addError) {
            if (!addError.status || Number(addError.status) >= 500) addError.kinsoraUnsafeCartState = true;
            throw addError;
          }
          committed = true;
          return actual;
        };
        // The shared gate runs this proof before it releases checkout.
        // The drawer and Add button do not wait for that proof.
        operation.kinsoraOnCommitted = revealCartAfterAdd;
        operation.kinsoraReturnsFreshCart = true;
        operation.kinsoraVerifyCanonicalCart = function(canonical) {
          if (prepared && !bogoController.verify(prepared, canonical)) {
            var error = new Error('Your cart could not be verified. Refresh this page before trying again.');
            error.kinsoraUnsafeCartState = true;
            throw error;
          }
        };
        var readyRunner = window.Kinsora && typeof window.Kinsora.runWhenSynchronizedPaidCartMutationReady === 'function'
          ? window.Kinsora.runWhenSynchronizedPaidCartMutationReady
          : null;
        var request;
        var generation = ++addGeneration;
        try {
          request = readyRunner
            ? readyRunner(operation)
            : Promise.reject(new Error('The secure cart runtime is unavailable.'));
        } catch (requestError) {
          request = Promise.reject(requestError);
        }
        request
          .then(function(canonical) {
            if (generation !== addGeneration) return;
            if (prepared && !bogoController.verify(prepared, canonical)) throw new Error('Your cart could not be verified. Refresh this page before trying again.');
            if (bogoController && prepared && typeof bogoController.complete === 'function') bogoController.complete();
            if (cartRevealed) return;
            if (window.Kinsora && window.Kinsora.openCart) {
              window.Kinsora.openCart();
            } else {
              window.location.href = rootPath + 'cart';
            }
          })
          .catch(function(error) {
            if (generation !== addGeneration) return;
            settleExpressVerification(false);
            // The line is already in the open cart. Leave the Add button usable.
            // Checkout stays paused via the cart runtime's own lock.
            if (cartRevealed && committed) {
              if (window.Kinsora && window.Kinsora.rewardSyncFailed) {
                errorNode.textContent = 'Your item was added. Checkout stays paused until the cart finishes updating.';
                errorNode.hidden = false;
              }
              if (bogoController && requireBogoPrepare && typeof bogoController.reportError === 'function') {
                bogoController.reportError(error);
              }
              return;
            }
            if (committed) {
              var committedError = error instanceof Error ? error : new Error('The cart could not finish updating.');
              committedError.message = 'Your items were added, but the cart could not finish updating. Refresh this page before trying again.';
              committedError.kinsoraUnsafeCartState = true;
              error = committedError;
            }
            if (error && error.kinsoraUnsafeCartState) {
              unsafeCartState = true;
              if (!/refresh/i.test(String(error.message || ''))) {
                error.message = 'Your cart could not be verified after this add. Refresh this page before trying again.';
              }
            }
            if (bogoController && requireBogoPrepare && typeof bogoController.reportError === 'function') {
              bogoController.reportError(error);
            }
            if (error && error.message) errorNode.textContent = error.message;
            errorNode.hidden = false;
          })
          .finally(function() {
            if (generation !== addGeneration) return;
            busy = false;
            renderPrice();
          });
      }

      function onSheetCancel(event) {
        event.preventDefault();
        closeActiveSheet(true);
      }

      function cleanup() {
        if (cleaned) return;
        cleaned = true;
        closeActiveSheet(false);
        if (controller) controller.abort();
        listenerRemovers.forEach(function(remove) { remove(); });
        listenerRemovers.length = 0;
        if (removalObserver) removalObserver.disconnect();
        if (root.ksPurchaseBoot) root.ksPurchaseBoot.dispose();
        delete root.ksPdpSelection;
        delete root.ksSelectVariant;
        delete root.ksPdpBogo;
        delete root.ksPurchaseCleanup;
        root.removeAttribute('data-ks-initialized');
        root.setAttribute('data-ks-purchase-state', 'loading');
        if (addButton) addButton.disabled = true;
      }

      root.ksPurchaseCleanup = cleanup;
      rebuildLockedVariantIds();
      setDeliveryEstimate();
      render();

      listen(root, 'click', onRootClick);
      listen(root, 'kinsora:pdp-bogo-state', onBogoState);
      listen(document, 'kinsora:offer-updated', function() { renderIncluded(); renderPrice(); });
      listen(document, 'keydown', onDocumentKeydown);
      listen(addButton, 'click', onAddToCart);
      listen(detailsAddButton, 'click', onDetailsAddToCart);
      listen(document, 'click', onOriginalStickyClick, {capture: true});
      listen(detailsSheet, 'cancel', onSheetCancel);
      listen(pickerSheet, 'cancel', onSheetCancel);
      listen(document, 'shopify:section:unload', function(event) {
        if (!root.isConnected || (event.target && event.target.contains && event.target.contains(root))) cleanup();
      });

      if ('MutationObserver' in window) {
        removalObserver = new MutationObserver(function() { if (!root.isConnected) cleanup(); });
        if (root.parentNode) removalObserver.observe(root.parentNode, {childList: true});
      }

      if (document.readyState === 'loading') {
        listen(document, 'DOMContentLoaded', function() {
          window.requestAnimationFrame(syncOriginalSticky);
        }, {once: true});
      } else {
        window.requestAnimationFrame(syncOriginalSticky);
      }
      root.setAttribute('data-ks-purchase-state', 'ready');
      var loadError = root.querySelector('[data-ks-purchase-load-error]');
      if (loadError) loadError.hidden = true;
      if (root.ksPurchaseBoot) root.ksPurchaseBoot.ready();
  }

  function init(scope) {
    if (!scope) return;
    var roots = [];
    if (scope.matches && scope.matches('[data-ks-set-purchase]')) roots.push(scope);
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-ks-set-purchase]'), function(root) { roots.push(root); });
    }
    roots.forEach(function(root) {
      if (!root.isConnected) return;
      try {
        mount(root);
      } catch (error) {
        if (root.ksPurchaseCleanup) root.ksPurchaseCleanup();
        delete root.ksPdpSelection;
        delete root.ksSelectVariant;
        root.removeAttribute('data-ks-initialized');
        failRoot(root);
      }
    });
  }

  function blockPendingPurchase(event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-fb-atc], .kinsora-express-btn, .sticky-atc__btn') : null;
    if (!target) return;
    var root = target.closest('[data-ks-set-purchase]');
    if (!root && target.closest('#stickyATC')) root = document.querySelector('[data-ks-set-purchase][data-purchase-mode="single"]');
    if (!root && target.closest('#stickyATCStack')) root = document.querySelector('[data-ks-set-purchase]:not([data-purchase-mode="single"])');
    if (!root || root.getAttribute('data-ks-purchase-state') === 'ready') return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  window.KinsoraSetPurchase = {init: init};
  document.addEventListener('click', blockPendingPurchase, true);
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); }, {once: true});
  }
})();



